<template>
  <div>
    <div class="d-flex justify-center align-center my-4">
      <v-progress-circular
        :size="size"
        color="primary"
        indeterminate
      ></v-progress-circular>

      <v-progress-circular
        :size="size * 2"
        color="secondary"
        class="mx-2"
        indeterminate
      ></v-progress-circular>

      <v-progress-circular
        :size="size"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <p :class="[
      'text-center',
      `${$vuetify.breakpoint.smAndDown ? 'subtitle-1' : 'title'}`,
      'ma-0',
      'font-weight-bold',
      'primary--text'
    ]">
      {{ title }}
    </p>
    <p pa-1 :class="[
      'text-center',
      `${$vuetify.breakpoint.smAndDown ? 'caption' : 'body-2'}`,
      'font-weight-light',
      'secondary--text'
    ]">
      {{ subtitle }}
    </p>
  </div>
</template>

<script>
export default {
  props: ['size', 'title', 'subtitle'],
};
</script>
